import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { GATEWAYS } from "../../lib/data";

const GatewayCard = ({ item, index }) => {
  const navigate = useNavigate();
  return (
    <motion.button
      type="button"
      data-testid={`gateway-${item.key}`}
      aria-label={
        item.key === "clients"
          ? `Explore ${item.title} — view the A to Z index`
          : item.key === "people"
          ? `Explore ${item.title} — view the record`
          : item.key === "stories"
          ? `Explore ${item.title} — read the stories`
          : item.key === "work"
          ? `Explore ${item.title} — see the work`
          : `Explore ${item.title} — coming soon`
      }
      onClick={() => navigate(`/${item.key}`)}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      className="group relative isolate overflow-hidden text-left min-h-[340px] sm:min-h-[420px] border border-white/12 flex flex-col justify-end p-8 sm:p-10 focus:outline-none focus:ring-2 focus:ring-[#e62429]"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={item.image}
          alt={item.title}
          className="h-full w-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-[filter,transform] duration-[900ms]"
        />
        <div className="absolute inset-0 bg-[#0a0a0a]/60 group-hover:bg-[#0a0a0a]/40 transition-colors duration-500" />
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-70 transition-opacity duration-500 mix-blend-multiply"
          style={{ backgroundColor: item.color }}
        />
      </div>

      <div className="relative z-10 flex items-start justify-between">
        <div>
          <span
            className="inline-block h-1.5 w-12 mb-6"
            style={{ backgroundColor: item.color }}
          />
          <h3 className="font-display uppercase text-5xl sm:text-6xl text-white leading-none">
            {item.title}
          </h3>
          <p className="mt-4 max-w-xs text-neutral-300 group-hover:text-white text-base leading-relaxed transition-colors">
            {item.body}
          </p>
        </div>
        <span className="flex h-12 w-12 shrink-0 items-center justify-center border border-white/40 group-hover:bg-white group-hover:text-black transition-colors duration-300">
          <ArrowUpRight className="h-6 w-6" />
        </span>
      </div>
      <span
        className={`relative z-10 mt-6 text-[10px] uppercase tracking-[0.3em] font-bold text-white`}
      >
        {item.key === "clients"
          ? "View index →"
          : item.key === "people"
          ? "View the record →"
          : item.key === "stories"
          ? "Read the stories →"
          : item.key === "work"
          ? "See the work →"
          : "Coming soon"}
      </span>
    </motion.button>
  );
};

export const Gateways = () => {
  return (
    <section
      id="gateways"
      data-testid="gateways-section"
      className="relative bg-[#0a0a0a] py-24 sm:py-36"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-8">
        <Reveal>
          <p className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-[#e62429] mb-6">
            <span className="h-px w-10 bg-[#e62429]" /> If you'd like to look further
          </p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl lg:text-7xl leading-[0.9] max-w-4xl">
            Choose what interests you.
          </h2>
          <p className="mt-6 text-neutral-400 text-lg max-w-xl">
            Four ways to go deeper. Open a door — or simply get in touch. A
            conversation is usually a better place to start.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
          {GATEWAYS.map((item, i) => (
            <GatewayCard key={item.key} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
